import { useState, useEffect, useContext } from "react";
import { ShopContext } from "../../../../config/shopContext";
import {
  useLazyGetFilteredShopsQuery,
  useGetShopCategoriesQuery,
} from "../../../../features/shop/shopApiSlice";

export const useBuyRetailerState = () => {
  const shopType = "retailerShop";
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const [dataCategory, setDataCategory] = useState({ categoryid: "" });
  const [shopCategorytwo, setShopCategorytwo] = useState();

  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [itemmdata, setItemmdata] = useState(currentData.itemmdata || []);
  
  const [filters, setFilters] = useState(currentData.additionalData || {
    shopname: "", shopCategory: "", marketPlace: "", shopid: "",
    specialoffer: "", sale: "", itemname: "", categoryid: "",
    subCategoryid: "", country: "", state: "", city: "", 
    salespromotion: "", min: "", max: ""
  });

  // Pagination states
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 15;
  const [currentFilterMethod, setCurrentFilterMethod] = useState("shop");

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];

  useEffect(() => {
    setFilters(prev => ({ ...prev, categoryid: categoryidone || "" }));
  }, [categoryidone]);

  useEffect(() => {
    let initial = { ...filters };
    let hasSearch = false;
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const searchParam = urlParams.get("search");
      if (searchParam) {
        hasSearch = true;
        initial = { ...initial, shopname: searchParam, itemname: searchParam };
        setFilters(initial);
      }
    } catch (e) {}

    // When query is present, use "shopitem" to match item names and shops simultaneously
    executeFilter(hasSearch ? "shopitem" : "shop", 1, initial);
  }, [window.location.search]);

  useEffect(() => {
    const handleVoiceSearchOnPage = (e) => {
      const q = e?.detail?.query;
      if (q) {
        const updated = { ...filters, shopname: q, itemname: q };
        setFilters(updated);
        executeFilter("shopitem", 1, updated);
      }
    };
    window.addEventListener("selectezi:voicesearch", handleVoiceSearchOnPage);
    return () => {
      window.removeEventListener("selectezi:voicesearch", handleVoiceSearchOnPage);
    };
  }, [filters]);

  // RTK Queries
  const { data: createshopcategoryRes } = useGetShopCategoriesQuery({
    type: "retailerShop",
    parentCategory: "",
  });
  const createshopcategory = createshopcategoryRes?.data?.Category;

  const { data: shopCategoryRes } = useGetShopCategoriesQuery({
    type: "retailerShop",
    parentCategory: "true",
  });
  const shopCategory = shopCategoryRes?.data?.Category;

  const { data: shopCategorytwoRes } = useGetShopCategoriesQuery(
    { type: "retailerShopItem", parentCategory: categoryName },
    { skip: !categoryName }
  );
  
  const Mydata = () => {
    if (shopCategorytwoRes?.data?.Category) {
      setShopCategorytwo(shopCategorytwoRes.data.Category);
    }
  };

  const [triggerFilter, { data: filterResult, isLoading, isFetching }] = useLazyGetFilteredShopsQuery();

  useEffect(() => {
    if (filterResult?.success) {
      setShopdata(filterResult.Shop || []);
      setItemmdata(filterResult.ShopItem || []);
      setTotalPages(filterResult.totalPages || 1);
      updateFilteredData(shopType, filterResult.Shop || [], filterResult.ShopItem || [], filters);
    }
  }, [filterResult]);

  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => { setShowshare(false); setShowmodal(true); };
  const handleShowshare = () => setShowshare(true);

  const Handledata = (e) => {
    setDataCategory(prev => ({
      ...prev,
      [e.target.name]: e.target.value.split(".")
    }));
  };

  const Handleadditioanalshop = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    // Category select value is "id.name" — store only the ObjectId for API queries.
    if (name === "categoryid" && typeof value === "string" && value.includes(".")) {
      value = value.split(".")[0];
    }
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const executeFilter = async (method, pageNum = 1, overrideFilters = null) => {
    setCurrentFilterMethod(method);
    setPage(pageNum);

    // Build the query object
    const query = {
      businessType: "retailerShop",
      filtermethod: method,
      page: pageNum,
      limit,
    };

    const keys = method === "shop"
      ? ["shopname", "shopCategory", "marketPlace", "shopid", "specialoffer", "sale"]
      : ["itemname", "categoryid", "subCategoryid", "country", "state", "city", "specialoffer", "salespromotion", "min", "max"];

    const activeFilters = overrideFilters || filters;

    const ignoreValues = [
      "Shop Category", "Sale", "Special Offer", "Category", 
      "Select Sub Category", "Select country", "Select state", "Select city"
    ];

    keys.forEach((k) => {
      let val = activeFilters[k];
      if (val == null || val === "") return;
      // Inputs are strings; also accept numbers for min/max.
      if (typeof val !== "string") val = String(val);
      val = val.trim();
      if (!val || ignoreValues.includes(val)) return;
      // Normalize leftover "id.name" category values from older state/context.
      if (k === "categoryid" && val.includes(".")) {
        val = val.split(".")[0];
      }
      query[k] = val;
    });

    try {
      await triggerFilter(query).unwrap();
    } catch (err) {
      console.error("Filter failed:", err);
    }
  };

  const FilterHandler = () => {
    const newFilters = { ...filters, itemname:"", categoryid:"", subCategoryid:"", country:"", state:"", city:"", salespromotion:"", specialoffer:"", min:"", max:"" };
    setFilters(newFilters);
    executeFilter("shop", 1, newFilters);
  };

  const FilterHandleritem = () => {
    // Clear shop-detail fields only. Keep item filters (itemname, category,
    // specialoffer, salespromotion, location, price) so item search works.
    const newFilters = {
      ...filters,
      shopname: "",
      shopCategory: "",
      marketPlace: "",
      shopid: "",
      sale: "",
    };
    if (
      newFilters.categoryid &&
      String(newFilters.categoryid).includes(".")
    ) {
      newFilters.categoryid = String(newFilters.categoryid).split(".")[0];
    }
    setFilters(newFilters);
    executeFilter("shopitem", 1, newFilters);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      executeFilter(currentFilterMethod, newPage);
    }
  };

  return {
    isloading: isLoading || isFetching,
    createshopcategory,
    shopCategory,
    shopCategorytwo,
    showmodal,
    showshare,
    dataCategory,
    shopdata,
    itemmdata,
    filters,
    page,
    totalPages,
    handleClosemodal,
    handleShow,
    handleCloseshare,
    handleShowshare,
    Handledata,
    Mydata,
    Handleadditioanalshop,
    FilterHandler,
    FilterHandleritem,
    handlePageChange
  };
};
